import http from "../utils/http";
//
/**
 *  公共接口
 */

/** 获取区域数据 省市区三级联动 */
export function getRegion(params) {
  return http.get(`common/region`, params);
}
/** 获取导航菜单 */
export function getNavBar(params) {
  return http.get(`common/nav`, params);
}

/** 获取右侧悬浮框_右上角角标数量+搜索热词 */
export function getRightNumAndHotWords(params) {
  return http.get(`/index/right_count`, params);
}

/** 获取公共为你推荐*/
export function getRecommend(params) {
  return http.get(`/index/to_you`, params);
}

/** 获取footer*/
export function getFooter(params) {
  return http.get(`/index/footer_help`, params);
}

/*
 * 发送验证码
 * */
export function sendVerify(params) {
  return http.post(`common/sendVerify`, params);
}

/** 获取会员等级 */
export function getRankList(params) {
  return http.get(`/common/rank`, params);
}

/** 获取注册用户信息查重 */
  export function getUserCheck(params) {
  return http.post(`/common/checkData`, params);
}




// WEBPACK FOOTER //
// ./src/api/commonApi.js